import { useQuery } from "react-query";
import { useAccessToken } from "hooks/useAccessToken";
import { QUERY_STALE_TIME } from "utils/constants";
import queryAnnualCarbonEmissionsCard from "ApiLayer/Reports/Baseline/queryAnnualCarbonEmissionsCard";

export const useAnnualCarbonEmissionsCard = (filtersetUid: string) => {
    const accessToken = useAccessToken();

    return useQuery({
        queryKey: ["annualCarbonEmissionsCard", filtersetUid],
        queryFn: async () =>
            queryAnnualCarbonEmissionsCard(accessToken, {
                reportFiltersetUid: filtersetUid,
            }),
        staleTime: QUERY_STALE_TIME,
    });
};
